import React from 'react';
import '../styles/ShareButton.css';

/**
 * ShareButton — small icon rendered next to each assistant message.
 * When clicked, it calls `onShare(messageData)` which the parent
 * uses to open the EmailComposer modal.
 *
 * Props:
 *   message  — the full message object (content, data, columns, etc.)
 *   onShare  — callback: (messageData) => void
 */
const ShareButton = ({ message, onShare }) => {
  if (!message || message.isUser) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    onShare({
      question: message._originalQuestion || '',
      response: message.content || '',
      data: message.data || null,
      columns: message.columns || null,
      conversationId: message.conversationId || '',
      messageId: message.messageId || message.id || '',
    });
  };

  return (
    <button
      className="share-btn"
      onClick={handleClick}
      title="Share via Email"
      aria-label="Share this response via email"
    >
      <svg
        className="share-btn__icon"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.333 7.5L17.5 11.667 13.333 15.833"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 11.667H7.5C5.199 11.667 3.333 9.801 3.333 7.5V4.167"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ShareButton;
